import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_kpi_value_compare_input = _resolveComponent("kpi-value-compare-input");
  const _component_a_input_number = _resolveComponent("a-input-number");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_space_compact = _resolveComponent("a-space-compact");
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest");
  return _openBlock(), _createBlock(_component_a_form_item_rest, null, {
    default: _withCtx(() => [_createVNode(_component_a_space_compact, {
      block: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_kpi_value_compare_input, {
        value: $setup.formData.compareMode,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.formData.compareMode = $event),
        onBlur: $setup.handleBlur
      }, null, 8, ["value", "onBlur"]), $setup.isQuantized ? (_openBlock(), _createBlock(_component_a_input_number, {
        key: 0,
        value: $setup.formData.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => $setup.formData.value = $event),
        style: {
          "width": "90px"
        },
        onBlur: $setup.handleBlur
      }, null, 8, ["value", "onBlur"])) : _createCommentVNode("", true), $setup.isQuantized ? (_openBlock(), _createBlock(_component_a_input, {
        key: 1,
        value: $setup.formData.unit,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => $setup.formData.unit = $event),
        placeholder: "计量单位",
        style: {
          "width": "100px"
        },
        onBlur: $setup.handleBlur
      }, null, 8, ["value", "onBlur"])) : _createCommentVNode("", true), $setup.isNonQuantized ? (_openBlock(), _createBlock(_component_a_input, {
        key: 2,
        value: $setup.formData.nValue,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => $setup.formData.nValue = $event),
        placeholder: "非量化指标值",
        style: {
          "width": "190px"
        },
        onBlur: $setup.handleBlur
      }, null, 8, ["value", "onBlur"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  });
}